import { render, staticRenderFns } from "./CookiePolicy.vue?vue&type=template&id=00e48d70&scoped=true"
import script from "./CookiePolicy.vue?vue&type=script&lang=js"
export * from "./CookiePolicy.vue?vue&type=script&lang=js"
import style0 from "./CookiePolicy.vue?vue&type=style&index=0&id=00e48d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e48d70",
  null
  
)

export default component.exports